export const errorTitleText = 'Maaf, Terjadi Kesalahan di Siglive ...';
export const errorDescText =
  'Saat ini, kami tidak dapat memastikan masalah yang terjadi. Coba muat ulang halaman, atau kembali ke halaman login.';
export const logoutText = 'Logout';
export const reloadtText = 'Muat Ulang';
